import { createAction, createAsyncAction } from 'typesafe-actions';

export const getAgreementDebt = createAsyncAction(
  '@GET_DEALDEBT/REQUEST',
  '@GET_DEALDEBT/SUCCESS',
  '@GET_DEALDEBT/FAILURE'
)<undefined, Array<GQL.IDeal>, string>();

export const getAgreementPortionDebt = createAsyncAction(
  '@GET_AGREEMENTDEBT/REQUEST',
  '@GET_AGREEMENTDEBT/SUCCESS',
  '@GET_AGREEMENTDEBT/FAILURE'
)<{ dealId: number; databaseId: number }, Array<GQL.IPortion>, string>();

export const getBilletDeal = createAsyncAction(
  '@GET_DEALBILLET/REQUEST',
  '@GET_DEALBILLET/SUCCESS',
  '@GET_DEALBILLET/FAILURE'
)<
  {
    dealId: number;
    portionId: number;
    type: string;
    databaseId: number;
    callBack: (billet: {
      linhaDigitavel: string;
      nnumero: string;
      doc: string;
    }) => void;
  },
  GQL.IBillet,
  string
>();

export const getLinhaDigitavelDealBillet = createAsyncAction(
  '@GET_LINHADIGDEALBILLET/REQUEST',
  '@GET_LINHADIGDEALBILLET/SUCCESS',
  '@GET_LINHADIGDEALBILLET/FAILURE'
)<
  {
    dealId: number;
    portionId: number;
    sendType: string;
    databaseId: number;
    callBack: (sendType: GQL.SendType, billet: GQL.IBillet) => void;
    creditorId: number;
  },
  GQL.IBillet,
  string
>();

export const setAgreementStatus = createAction('@AGREEMENT/SET_STATUS')<string>();
